import { render } from "./proof_of_payments.html?vue&type=template&id=3ee77170&external"
import script from "./proof_of_payments.js?vue&type=script&lang=js&external"
export * from "./proof_of_payments.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__